import DoneIcon from '@mui/icons-material/Done';
import settings from '/@/core/settings';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const Hybrids = (props) => {
    return (
        <div className={styles.hybridPill}>
            <DoneIcon sx={{ fontSize: 20, color: (t) => t.palette.primary.main }} />
            <div className={styles.hybrid}>
                <Title theme={settings.app.theme} size='md'>
                    {props.hybrid}
                </Title>
            </div>
        </div>
    );
};

export default Hybrids;
